import { supabase } from './supabaseClient';
import { mockCases, mockClients } from '../data/mockData';
import type { CaseItem, ClientItem } from '../types';

/** cases 表原始行类型：兼容新版 tags 数组字段与旧版单值 tag 字段 */
interface CaseRow {
  id: number;
  tags?: string[];
  tag?: string;
  title: string;
  description: string;
  image: string;
}

/**
 * 案例数据：优先从 Supabase 的 cases 表加载，
 * 未配置或加载失败时回退到本地模拟数据。
 */
export async function fetchCases(): Promise<CaseItem[]> {
  if (!supabase) return mockCases;

  try {
    const { data, error } = await supabase
      .from('cases')
      .select('*')
      .order('id', { ascending: true });

    if (error) throw error;
    if (!data || data.length === 0) return mockCases;

    return (data as unknown as CaseRow[]).map((item) => ({
      id: item.id,
      // 兼容旧库：优先 tags 数组，否则把旧字段 tag（单字符串）包成数组
      tags: Array.isArray(item.tags) && item.tags.length
        ? item.tags
        : typeof item.tag === 'string' && item.tag
          ? [item.tag]
          : [],
      title: item.title,
      description: item.description,
      image: item.image,
    }));
  } catch (err) {
    console.warn('[SAWISAFETY] 案例数据加载失败，已回退到本地数据：', err);
    return mockCases;
  }
}

/**
 * 客户数据：优先从 Supabase 的 clients 表加载，
 * 未配置或加载失败时回退到本地模拟数据。
 */
export async function fetchClients(): Promise<ClientItem[]> {
  if (!supabase) return mockClients;

  try {
    const { data, error } = await supabase
      .from('clients')
      .select('*')
      .order('sort_order', { ascending: true });

    if (error) throw error;
    if (!data || data.length === 0) return mockClients;

    return (data as unknown as ClientItem[]).map((item) => ({
      id: item.id,
      name: item.name,
      logo: item.logo,
    }));
  } catch (err) {
    console.warn('[SAWISAFETY] 客户数据加载失败，已回退到本地数据：', err);
    return mockClients;
  }
}
